/* El Gummo — winkelgedrag: staffelkiezer, abonnement, mix & match, gallerij.
   Prijzen hier moeten gelijk zijn aan wat de kassa rekent:
   staffel  = automatische korting (2 potjes -€9,95 / 3 -€19,90 / 5 -€49,80)
   abonnement = Seal-verkoopplannen 3/6/12 maanden = 10/20/30% per potje. */
(function () {
  "use strict";

  var LIST = 29.95;
  /* Verzendkosten en gratis-drempel horen bij het land van de bezoeker, niet bij
     Nederland alleen. Valt het land buiten de lijst, dan pakken we Nederland als
     veilige standaard — dat is waar bijna al het verkeer vandaan komt. */
  var VZ = (window.EG_VERZEND && window.EG_VERZEND[window.EG_LAND]) ||
           { kosten: 6.65, drempel: 40.00 };
  var SHIP = VZ.kosten, FREE_SHIP = VZ.drempel;
  /* De echte Seal-plannen: alle drie maandelijkse levering, 10/20/30% per potje.
     De staffelkorting geldt sinds 4 sep niet meer op abonnementen, dus reken hier
     puur met de adviesprijs maal het plan. */
  var TERM = { 3: 0.10, 6: 0.20, 12: 0.30 };
  /* Vier potjes was vorig jaar 44% van alle Black Friday-bestellingen, meer dan
     twee en drie samen, en stond niet in de kiezer. 'Meest gekozen' staat daarom
     op vier: dat klopt met wat mensen kiezen en het is de eerste trede waar een
     nieuwe klant zichzelf terugverdient. De vijfde trede heette "4 + 1 gratis";
     in november gaat er geen potje gratis mee, het is 40% korting op vijf. */
  var TIERS = [
    { q: 1, label: "1 potje" },
    { q: 2, label: "2 potjes" },
    { q: 3, label: "3 potjes" },
    { q: 4, label: "4 potjes", flag: "Meest gekozen" },
    { q: 5, label: "5 potjes", flag: "Beste prijs", best: true }
  ];
  var SMAKEN = [
    { k: "blackseed", h: "1-stuk",               n: "Zwarte Zaad" },
    { k: "shilajit",  h: "shilajit-gummies",     n: "Shilajit" },
    { k: "matcha",    h: "matcha-gummies",       n: "Matcha" },
    { k: "cranberry", h: "cranberry-gummies",    n: "Cranberry" },
    { k: "kids",      h: "1-stuk-kids-gummies",  n: "Kids" }
  ];

  /* Black Friday. In november rekent de kassa met percentages (30% vanaf twee potjes,
     35% vanaf drie, 40% vanaf vijf); daarbuiten met de vaste staffelbedragen. Shopify past altijd de
     voordeligste van de twee toe, dus dat doen we hier ook — anders toont de site een
     maand lang andere prijzen dan er wordt afgerekend.
     Wijzigt de actie in Shopify, wijzig deze getallen dan mee. */
  var BF_START = Date.parse("2026-11-01T00:00:00+01:00");
  var BF_EIND  = Date.parse("2026-12-01T00:00:00+01:00");
  function inBF() { var n = Date.now(); return n >= BF_START && n < BF_EIND; }
  function staffel(q) {
    /* Vanaf zes potjes een percentage in plaats van een vast bedrag. Het vaste
       bedrag groeide niet mee, waardoor elk potje boven de vijf weer EUR 29,95
       kostte en tien potjes per stuk duurder waren dan drie. 33,4% van EUR 29,95
       is EUR 19,95, dus elke extra pot kost nu hetzelfde. Gelijk aan de korting
       "Staffel 6+ potjes" in Shopify. */
    /* Afronden NAAR BENEDEN, want zo rekent Shopify het af. Met Math.round
       toonde de site EUR 119,68 terwijl de kassa EUR 119,69 vroeg. */
    var vast = q >= 6 ? Math.floor(q * LIST * 0.334 * 100) / 100
             : q >= 5 ? 49.80 : q >= 3 ? 19.90 : q >= 2 ? 9.95 : 0;
    if (!inBF()) return vast;
    var pct = q >= 5 ? 0.40 : q >= 3 ? 0.35 : q >= 2 ? 0.30 : 0;
    /* Shopify kapt de halve cent af in plaats van hem op te ronden: 35% van
       EUR 89,85 is 31,4475 en daar rekent de kassa 31,44 van, niet 31,45.
       Met Math.round toonde de site EUR 58,40 terwijl de kassa 58,41 vroeg.
       Rekenen in hele centen, en die 1e-6 vangt de drijvende komma op:
       5990 x 0,30 komt in JavaScript uit op 1796,9999... en zou anders
       naar 1796 worden afgekapt. */
    var bf = Math.floor(Math.round(q * LIST * 100) * pct + 1e-6) / 100;
    return vast > bf ? vast : bf;
  }
  function once(q) { return q * LIST - staffel(q); }
  function abo(t) {
    /* Shopify rekent in hele centen en rondt half naar boven af: 2995 x 0,70 = 2096,5
       wordt 2097. Rekenen we hier in euro's, dan toont het scherm €20,96 en rekent de
       kassa €20,97 — precies het soort verschil waar een klant over mailt. */
    return Math.round(LIST * 100 * (1 - TERM[t])) / 100;
  }
  function eur(n) { return "€" + n.toFixed(2).replace(".", ","); }

  /* Wat iemand er echt bij betaalt om van de ene tree naar de volgende te gaan:
     het prijsverschil, min de verzendkosten die boven de drempel wegvallen.
     Zonder dit noemde de wagen 20,00 voor een tweede potje terwijl het er 13,35
     zijn - precies de 6,65 verzending die vervalt. Je aanbod duurder tonen dan
     het is, kost bestellingen. */
  function vracht(p) { return (FREE_SHIP !== null && p >= FREE_SHIP) ? 0 : SHIP; }
  function meerkosten(vanPrijs, naarPrijs) {
    var d = (naarPrijs + vracht(naarPrijs)) - (vanPrijs + vracht(vanPrijs));
    return Math.max(0, Math.round(d * 100) / 100);
  }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var state = { tier: 3, plan: "once", subTerm: 12, subQty: 1 };

  /* ---------- staffelkiezer ---------- */
  function ladderHTML(dagenPerPot) {
    return TIERS.map(function (t, i) {
      var prijs = once(t.q), per = prijs / t.q, save = t.q * LIST - prijs;
      var jars = new Array(Math.min(t.q, 5) + 1).join("<i></i>");
      var flag = t.flag ? '<span class="rung__save' + (t.best ? " rung__save--best" : "") + '">' + t.flag + "</span>" : "";
      return '<button type="button" class="rung" role="radio" aria-checked="' + (i === state.tier) + '" data-i="' + i + '">' + flag
        + '<span class="rung__radio"></span><span><span class="rung__jars">' + jars + "</span>"
        + '<span class="rung__t">' + t.label + "</span></span>"
        + '<span class="rung__pr">' + (save ? '<s class="num rung__was">' + eur(t.q * LIST) + "</s>" : "")
        /* Prijs per potje eruit: op de plek waar iemand kiest is het te veel
           informatie. De doorgehaalde prijs en het bedrag zeggen genoeg. */
        + '<b class="num">' + eur(prijs)
        /* Verzending hoort bij de keuze, niet in een los tekstblok eronder.
           Onder de drempel het bedrag erbij, daarboven gewoon gratis. */
        + '<span class="rung__vz">' + (vracht(prijs) > 0
            ? "+ " + eur(vracht(prijs)) + " verzending"
            : "Gratis verzending")
        + '</span></span></button>';
    }).join("");
  }

  function tekenLadders() {
    $$("[data-eg-ladder]").forEach(function (el) { el.innerHTML = ladderHTML(); });
    var p = once(TIERS[state.tier].q);
    /* Zonder drempel is verzending nooit gratis; dan niets beloven. */
    var gratis = FREE_SHIP !== null && p >= FREE_SHIP;
    /* Drie gevallen: gratis, nog niet gratis maar wel haalbaar, en landen waar
       verzending nooit gratis is. Dat laatste geval noemde eerder een drempel
       die daar niet bestaat, en rekende met null. */
    var tekst = gratis
      ? "Gratis verzending inbegrepen. Je betaalt " + eur(p) + " — verder niets."
      : FREE_SHIP === null
        ? "Er komt " + eur(SHIP) + " verzending bij, dus je betaalt " + eur(p + SHIP) + "."
        : "Let op: onder " + eur(FREE_SHIP) + " komt er " + eur(SHIP)
          + " verzending bij, dus je betaalt " + eur(p + SHIP)
          + ". Nog " + eur(FREE_SHIP - p) + " en verzenden is gratis.";
    /* Dit blok stond vol uitleg over de verzenddrempel. Die staat nu per trede
       in de kiezer zelf, dus hier hoeft niets meer te staan. */
    $$("[data-eg-laddernote]").forEach(function (el) { el.hidden = true; });
    tekenKoop();
    tekenSprong();
  }

  /* ---------- bijkoopregel op de productpagina ----------
     Laat zien wat de volgende stap in de staffel kost, in euro's en niet in
     procenten: "voor €20,00 extra krijg je er nog een". Dat is de vraag die
     een klant op dat moment stelt. */
  function tekenSprong() {
    var blok = $("[data-eg-pdpsprong]");
    if (!blok) return;
    var nu = TIERS[state.tier] ? TIERS[state.tier].q : 1;
    var doel = nu < 2 ? 2 : nu < 3 ? 3 : nu < 4 ? 4 : nu < 5 ? 5 : 0;
    if (!doel || state.plan === "sub") { blok.hidden = true; return; }
    var erbij = doel - nu;
    /* Ook hier telt de verzending mee: van een naar twee potjes kost 13,35 en
       geen 20,00, omdat je boven de gratis-verzendingsgrens komt. */
    var nuPrijs = once(nu), doelPrijs = once(doel);
    var meer = meerkosten(nuPrijs, doelPrijs);
    var vervaltVracht = vracht(nuPrijs) > 0 && vracht(doelPrijs) === 0;
    var perStuk = meer / erbij;
    blok.hidden = false;
    /* Kort houden. De prijs per potje staat al in de staffelkiezer erboven;
       die hier herhalen maakte het blok alleen maar langer. */
    /* Zo kort mogelijk: het bedrag, en waarvoor. Gratis en extra dikgedrukt,
       want dat zijn de twee woorden waar iemand op beslist. */
    $("[data-eg-pdpsprongtxt]").innerHTML = vervaltVracht
      ? "Voor " + eur(meer) + ": <b>gratis</b> verzending plus een <b>extra</b> potje."
      : perStuk < 1
        ? "Nog " + eur(meer) + " erbij en je " + doel + "e potje is <b>gratis</b>."
        : "Voor " + eur(meer) + " krijg je er "
          + (erbij === 1 ? "een <b>extra</b> potje" : erbij + " <b>extra</b> potjes") + " bij.";
    $("[data-eg-pdpsprongknop]").textContent = erbij === 1
      ? "Maak er " + doel + " van" : "Ja, maak er " + doel + " van";
    $("[data-eg-pdpsprongknop]").setAttribute("data-eg-doel", doel);
  }

  /* ---------- abonnementspaneel ---------- */
  function plannen() {
    var el = $("[data-eg-plans]");
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }
  function planIdVoor(term) {
    var lijst = plannen(), zoek = term + " maanden";
    for (var i = 0; i < lijst.length; i++) if (lijst[i].naam === zoek) return lijst[i].id;
    return lijst.length ? lijst[0].id : null;
  }
  function opts(waarden, actief, attr) {
    return waarden.map(function (v) {
      return '<button type="button" aria-pressed="' + (v.v === actief) + '" data-' + attr + '="' + v.v + '">'
        + v.t + (v.s ? "<small>" + v.s + "</small>" : "") + "</button>";
    }).join("");
  }
  /* Welke looptijden zijn bij dit aantal echt goedkoper dan los bestellen?
     De staffelkorting geldt niet op abonnementen, dus bij twee of drie potjes
     is een korte looptijd duurder dan gewoon bestellen. Zulke combinaties
     bieden we niet aan &mdash; een klant hoort hier geen slechtere deal te vinden. */
  function geldigeTermijnen(q) {
    var los = once(q);
    return [3, 6, 12].filter(function (t) { return abo(t) * q < los; });
  }

  function tekenAbo() {
    var paneel = $("[data-eg-subpanel]");
    if (!paneel) return;

    $("[data-eg-subqty]").innerHTML = opts(
      [1, 2, 3].map(function (q) {
        return { v: q, t: q + (q === 1 ? " potje" : " potjes") };
      }), state.subQty, "q");

    var geldig = geldigeTermijnen(state.subQty);
    if (geldig.indexOf(state.subTerm) === -1) state.subTerm = geldig[geldig.length - 1] || 12;

    var korting = { 3: "10%", 6: "20%", 12: "30%" };
    $("[data-eg-subterm]").innerHTML = opts(
      geldig.map(function (t) {
        return { v: t, t: t + " maanden", s: eur(abo(t) * state.subQty) + " per levering" };
      }), state.subTerm, "t");

    var perLevering = abo(state.subTerm) * state.subQty;
    var los = once(state.subQty);
    var sup = $("[data-eg-subsupply] span");
    if (sup) {
      var weg = [3, 6, 12].filter(function (t) { return geldig.indexOf(t) === -1; });
      sup.textContent = "Je legt " + state.subTerm + " maanden vast en betaalt per levering. "
        + "Daarna loopt het door tegen dezelfde prijs en kun je elk moment stoppen."
        + (weg.length ? " Bij " + state.subQty + (state.subQty === 1 ? " potje" : " potjes")
            + " tonen we alleen de looptijden die goedkoper zijn dan los bestellen." : "");
    }

    $("[data-eg-subheadline]").textContent = "Elke maand " + state.subQty
      + (state.subQty === 1 ? " potje" : " potjes") + " voor " + eur(perLevering) + ".";
    var aantalEl = $("[data-eg-subaantal]");
    if (aantalEl) aantalEl.textContent = state.subQty + (state.subQty === 1 ? " potje" : " potjes");
    $("[data-eg-subwas]").textContent = eur(los);
    $("[data-eg-subper]").textContent = eur(perLevering);
    $("[data-eg-subsave]").textContent = "Je bespaart " + eur(los - perLevering)
      + " per levering, en verzending is gratis op elke levering \u2014 niet alleen de eerste.";
  }

  /* ---------- koopknop ---------- */
  function tekenKoop() {
    var form = $("[data-eg-pdp]");
    if (!form) return;
    var abonnement = state.plan === "sub" && $("[data-eg-subpanel]");
    var aantal = abonnement ? state.subQty : TIERS[state.tier].q;
    var prijs = abonnement ? abo(state.subTerm) * state.subQty : once(TIERS[state.tier].q);

    form.setAttribute("data-eg-aantal", aantal);
    var planId = abonnement ? planIdVoor(state.subTerm) : null;
    form.setAttribute("data-eg-planid", planId ? planId : "");
    $$("[data-eg-atcprice],[data-eg-saprice]").forEach(function (el) { el.textContent = eur(prijs); });

    var once_ = $("[data-eg-oncepanel]"), sub = $("[data-eg-subpanel]");
    if (sub) {
      /* De stijl van .subpanel werkt met de klasse "on", niet met het hidden-attribuut.
         Alleen hidden zetten liet het paneel onzichtbaar, hoe vaak je ook op
         Abonnement klikte. Allebei zetten, dan klopt het in beide richtingen. */
      sub.classList.toggle("on", !!abonnement);
      sub.hidden = !abonnement;
      if (once_) once_.hidden = !!abonnement;
    }
    $$("[data-plan]").forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-plan") === state.plan); });
  }

  /* ---------- mix & match ---------- */
  var mix = [];
  function tekenMix() {
    var rij = $("[data-eg-mixrow]");
    if (!rij) return;
    if (!mix.length) {
      /* Begin met hetzelfde aantal als de staffelkiezer hierboven. Stond dit op
         een potje, dan las de klant twee verschillende prijzen op een pagina:
         "3 potjes €69,95" in het koopblok en "1 potje €29,95" in mix & match. */
      var f = $("[data-eg-pdp]");
      var h = f ? f.getAttribute("data-handle") : null;
      var k = null;
      SMAKEN.forEach(function (s) { if (s.h === h) k = s.k; });
      if (!k) k = SMAKEN[0].k;
      var n = TIERS[state.tier] ? TIERS[state.tier].q : 1;
      for (var i = 0; i < n; i++) mix.push(k);
    }
    rij.innerHTML = SMAKEN.map(function (s) {
      var n = mix.filter(function (x) { return x === s.k; }).length;
      return '<div class="mix__c' + (n ? " on" : "") + '" data-mixk="' + s.k + '">'
        + '<img loading="lazy" src="' + (window.EG_JAR ? window.EG_JAR[s.k] : "") + '" alt="' + s.n + '">'
        + "<span>" + s.n + "</span>"
        + '<div class="mix__n"><button type="button" data-mixmin="' + s.k + '" aria-label="Minder ' + s.n + '">−</button>'
        + "<b>" + n + "</b>"
        + '<button type="button" data-mixplus="' + s.k + '" aria-label="Meer ' + s.n + '">+</button></div></div>';
    }).join("");
    var q = mix.length, p = once(q);
    $("[data-eg-mixprice]").textContent = q ? eur(p) : "\u2014";

    var bespaard = Math.round((q * LIST - p) * 100) / 100;
    var sub = q + (q === 1 ? " potje" : " potjes");
    if (bespaard > 0) sub += " \u00b7 je bespaart " + eur(bespaard);
    $("[data-eg-mixsub]").textContent = q ? sub : "Kies je potjes";

    /* Duwtje naar de volgende trede. Bij vier potjes kost het vijfde bijna niets;
       dat is precies het geval dat mensen anders over het hoofd zien. */
    var nudge = $("[data-eg-mixnudge]");
    if (nudge) {
      var volgende = null, ti;
      for (ti = 0; ti < TIERS.length; ti++) {
        if (TIERS[ti].q > q) { volgende = TIERS[ti].q; break; }
      }
      if (!q || !volgende) {
        nudge.textContent = "";
      } else {
        /* Alleen melden als de volgende trede bijna niets kost - bij vier potjes
           scheelt het vijfde vijf cent. Een regel als "bij 5 potjes betaal je X
           per potje" stond er altijd en zei niets; die is eruit. */
        var meer = Math.round((once(volgende) - p) * 100) / 100;
        var erbij = volgende - q;
        nudge.textContent = meer <= 5
          ? "Voor " + eur(meer) + " meer krijg je er " + erbij
            + (erbij === 1 ? " potje" : " potjes") + " bij."
          : "";
      }
    }

    $$("[data-mixset]").forEach(function (b) {
      b.classList.toggle("on", +b.getAttribute("data-mixset") === q);
    });
  }

  /* Snelkeuze 2 / 3 / 5 potjes. Vult aan met de smaak van deze pagina. */
  function zetMix(n) {
    var f = $("[data-eg-pdp]"), h = f ? f.getAttribute("data-handle") : null, k = null;
    SMAKEN.forEach(function (sm) { if (sm.h === h) k = sm.k; });
    if (!k) k = SMAKEN[0].k;
    while (mix.length > n) mix.pop();
    while (mix.length < n) mix.push(k);
    tekenMix();
  }

  function voegToe(regels) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: regels })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- bezorgregel ---------- */
  function bezorging() {
    var nu = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Amsterdam" }));
    var dagen = ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
    var voorbij = nu.getHours() > 23 || (nu.getHours() === 23 && nu.getMinutes() >= 30);
    var d = new Date(nu); d.setDate(d.getDate() + (voorbij ? 2 : 1));
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    $$("[data-eg-cutoff]").forEach(function (e) {
      /* Kort en waar: voor de afhaaltijd gaat hij vandaag de deur uit,
         daarna morgen. Geen uitleg over hoe laat dat precies is. */
      e.textContent = voorbij
        ? "Morgen verstuurd"
        : "Vandaag besteld, vandaag verstuurd";
    });
    $$("[data-eg-levdag]").forEach(function (e) { e.textContent = dagen[d.getDay()]; });
  }

  /* ---------- gebeurtenissen ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target;

    var rung = t.closest && t.closest(".rung");
    if (rung) { e.preventDefault(); state.tier = +rung.getAttribute("data-i"); tekenLadders(); return; }

    var mode = t.closest && t.closest("[data-plan]");
    if (mode) { e.preventDefault(); state.plan = mode.getAttribute("data-plan"); tekenAbo(); tekenKoop(); tekenSprong(); return; }

    var q = t.closest && t.closest("[data-q]");
    if (q) { e.preventDefault(); state.subQty = +q.getAttribute("data-q"); tekenAbo(); tekenKoop(); return; }
    var tm = t.closest && t.closest("[data-t]");
    if (tm) { e.preventDefault(); state.subTerm = +tm.getAttribute("data-t"); tekenAbo(); tekenKoop(); return; }

    var thumb = t.closest && t.closest("[data-eg-thumbs] button");
    if (thumb) {
      e.preventDefault();
      $("[data-eg-galmain]").src = thumb.getAttribute("data-src");
      /* Label hoort bij het eerste beeld; op een ander beeld zou het een
         etiketfoto afdekken. */
      var hoofd = $(".gal__main");
      if (hoofd) {
        var eerste = $$("[data-eg-thumbs] button")[0] === thumb;
        hoofd.classList.toggle("is-ander", !eerste);
      }
      $$("[data-eg-thumbs] button").forEach(function (b) { b.removeAttribute("aria-current"); });
      thumb.setAttribute("aria-current", "true");
      return;
    }

    var accb = t.closest && t.closest(".acc__b");
    if (accb) {
      e.preventDefault();
      var it = accb.closest(".acc__i");
      it.classList.toggle("open");
      accb.setAttribute("aria-expanded", it.classList.contains("open"));
      return;
    }

    var burger = t.closest && t.closest("[data-eg-menu]");
    if (burger) {
      e.preventDefault();
      var m = document.getElementById("egMobMenu");
      if (m) { m.hidden = !m.hidden; burger.setAttribute("aria-expanded", !m.hidden); }
      return;
    }

    var zet = t.closest && t.closest("[data-mixset]");
    if (zet) { e.preventDefault(); zetMix(+zet.getAttribute("data-mixset")); return; }
    var plus = t.closest && t.closest("[data-mixplus]");
    if (plus) { e.preventDefault(); mix.push(plus.getAttribute("data-mixplus")); tekenMix(); return; }
    var min = t.closest && t.closest("[data-mixmin]");
    if (min) {
      e.preventDefault();
      var k = min.getAttribute("data-mixmin"), i = mix.indexOf(k);
      if (i > -1) mix.splice(i, 1);
      tekenMix(); return;
    }

    var koop = t.closest && t.closest("[data-eg-koop]");
    if (koop) {
      e.preventDefault();
      var blok = $("[data-eg-pdp]");
      if (!blok) return;
      var vid = +blok.getAttribute("data-eg-variant");
      var aantal = +blok.getAttribute("data-eg-aantal") || 1;
      var plan = blok.getAttribute("data-eg-planid");
      var regel = { id: vid, quantity: aantal };
      if (plan) regel.selling_plan = +plan;
      var oudeTekst = koop.innerHTML;
      koop.disabled = true;
      voegToe([regel])
        .then(function (r) {
          if (r && r.status && r.status >= 400) throw new Error(r.description || "fout");
          window.location.href = "/cart";
        })
        .catch(function () {
          koop.disabled = false;
          koop.innerHTML = oudeTekst;
          alert("Het toevoegen lukte niet. Probeer het nog eens.");
        });
      return;
    }

    var min = t.closest && t.closest("[data-eg-min]");
    if (min) {
      e.preventDefault();
      var i = +min.getAttribute("data-eg-min");
      var nu = +min.parentElement.querySelector(".num").textContent;
      wijzig(i, Math.max(0, nu - 1));
      return;
    }
    var plus = t.closest && t.closest("[data-eg-plus]");
    if (plus) {
      e.preventDefault();
      var i2 = +plus.getAttribute("data-eg-plus");
      var nu2 = +plus.parentElement.querySelector(".num").textContent;
      wijzig(i2, nu2 + 1);
      return;
    }
    var weg = t.closest && t.closest("[data-eg-weg]");
    if (weg) { e.preventDefault(); wijzig(+weg.getAttribute("data-eg-weg"), 0); return; }

    var erbij = t.closest && t.closest("[data-eg-erbij]");
    if (erbij) {
      e.preventDefault();
      var id = (window.EG_VAR || {})[erbij.getAttribute("data-eg-erbij")];
      if (!id) return;
      erbij.disabled = true;
      voegToe([{ id: id, quantity: 1 }]).then(function () { window.location.reload(); });
      return;
    }
    var sprong = t.closest && t.closest("[data-eg-sprongknop]");
    if (sprong) {
      e.preventDefault();
      var aantal = +sprong.getAttribute("data-eg-erbijaantal") || 1;
      var eerste = (window.EG_EERSTE || 0);
      if (!eerste) return;
      sprong.disabled = true;
      voegToe([{ id: eerste, quantity: aantal }]).then(function () { window.location.reload(); });
      return;
    }

    var pdpsprong = t.closest && t.closest("[data-eg-pdpsprongknop]");
    if (pdpsprong) {
      e.preventDefault();
      var doel = +pdpsprong.getAttribute("data-eg-doel");
      for (var i = 0; i < TIERS.length; i++) if (TIERS[i].q === doel) state.tier = i;
      tekenLadders();
      return;
    }

    var qopt = t.closest && t.closest("[data-eg-qopt]");
    if (qopt) {
      e.preventDefault();
      var o = QUIZ[qi].opts[+qopt.getAttribute("data-eg-qopt")];
      Object.keys(o.s || {}).forEach(function (k) { qscore[k] += o.s[k]; });
      if (o.potjes) qpotjes = o.potjes;
      qi++;
      if (qi >= QUIZ.length) quizKlaar(); else tekenQuiz();
      return;
    }
    var qopnieuw = t.closest && t.closest("[data-eg-qopnieuw]");
    if (qopnieuw) { e.preventDefault(); qreset(); tekenQuiz(); return; }

    var mixcta = t.closest && t.closest("[data-eg-mixcta]");
    if (mixcta) {
      e.preventDefault();
      if (!mix.length) return;
      mixcta.disabled = true; mixcta.textContent = "Bezig…";
      var telling = {};
      mix.forEach(function (k) { telling[k] = (telling[k] || 0) + 1; });
      var ids = window.EG_VAR || {};
      var regels = Object.keys(telling).filter(function (k) { return ids[k]; })
        .map(function (k) { return { id: ids[k], quantity: telling[k] }; });
      voegToe(regels).then(function () { window.location.href = "/cart"; })
        .catch(function () { mixcta.disabled = false; mixcta.textContent = "Toevoegen"; });
      return;
    }
  });

  function veilig(naam, fn) {
    /* Vangnet: gaat er onderweg iets mis, dan blijft de rest van de pagina staan
       en zien we in de console welk onderdeel het was. Zonder dit zou een fout in
       bijvoorbeeld de bezorgregel de hele staffelkiezer meenemen. */
    try { fn(); } catch (e) { console.error("[El Gummo] " + naam + ":", e); }
  }

  /* ---------- winkelwagenpagina ---------- */
  function wijzig(regel, aantal) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: regel, quantity: aantal })
    }).then(function () { window.location.reload(); });
  }

  function tekenWagen() {
    var rij = $("[data-eg-xrow]");
    if (!rij) return;

    /* Vaak samen genomen: twee smaken die nog niet in de wagen liggen. */
    var inWagen = (window.EG_WAGEN || []).slice();
    var ids = window.EG_VAR || {}, jars = window.EG_JAR || {};
    var kies = SMAKEN.filter(function (s) { return inWagen.indexOf(s.h) === -1 && ids[s.k]; }).slice(0, 2);
    /* De prijs bij de knop is wat er werkelijk bij komt, niet de losse adviesprijs.
       Ligt er een potje in de wagen, dan kost een tweede er 13,35 bij en geen 29,95:
       de staffel haalt 9,95 weg en boven de 40 vervalt de verzending. Smaken tellen
       daarbij samen - nagemeten in de kassa. */
    var nNu = window.EG_AANTAL || 0;
    var prijsNu = (typeof window.EG_TOTAAL === "number") ? window.EG_TOTAAL : once(nNu);
    var erbijPrijs = meerkosten(prijsNu, once(nNu + 1));
    rij.innerHTML = kies.map(function (s) {
      return '<div class="xc"><img loading="lazy" src="' + jars[s.k] + '" alt="' + s.n + '">'
        + '<div class="xc__n">' + s.n + '</div><div class="xc__p num">+ ' + eur(erbijPrijs) + "</div>"
        + '<button type="button" class="btn btn--ghost btn--sm" data-eg-erbij="' + s.k + '">Toevoegen</button></div>';
    }).join("");

    /* Sprongblok: wat kost het volgende staffelniveau. */
    var n = window.EG_AANTAL || 0;
    var blok = $("[data-eg-sprong]");
    if (!blok) return;
    var doel = n < 2 ? 2 : n < 3 ? 3 : n < 5 ? 5 : 0;
    if (!doel) { blok.hidden = true; return; }
    var erbij = doel - n;
    /* Rekenen vanaf wat er echt in de wagen staat, niet vanaf de adviesprijs.
       Met een kortingscode is het huidige bedrag lager, en dan is het
       bijbetaalbedrag hoger dan de staffel alleen zou doen vermoeden. */
    var basis = (typeof window.EG_TOTAAL === "number") ? window.EG_TOTAAL : once(n);
    var doelPrijs = once(doel);
    var meer = meerkosten(basis, doelPrijs);
    var vervaltVracht = vracht(basis) > 0 && vracht(doelPrijs) === 0;
    blok.hidden = false;
    /* Bij vier potjes kost het vijfde nog vijf cent. "€0,05 per potje" is waar,
       maar leest als een storing — dan zeggen we gewoon waar het op neerkomt. */
    var perStuk = meer / erbij;
    $("[data-eg-sprongtxt]").innerHTML = perStuk < 1
      ? "Nog <b>" + eur(meer) + "</b> erbij en je " + doel + "e potje krijg je er gratis bij."
      /* Geen prijs per potje meer erbij. "Dat is EUR 20,00 per potje" sloeg op
         het extra potje, maar las als de prijs van de hele bestelling - en die
         is hoger. Een bedrag dat verkeerd gelezen kan worden hoort niet op een
         pagina waar iemand afrekent. */
      : "Voor <b>" + eur(meer) + "</b> extra krijg je er "
        + (erbij === 1 ? "nog een potje" : erbij + " potjes bij")
        + (vervaltVracht ? ", en je verzending is gratis." : ".");
    $("[data-eg-sprongknop]").textContent = "Ja, maak er " + doel + " van";
    $("[data-eg-sprongknop]").setAttribute("data-eg-erbijaantal", erbij);

    /* Drie potjes is de tree waar een nieuwe klant winst oplevert; een en twee niet.
       De sprongknop houdt de makkelijke stap (de eerstvolgende tree), deze regel wijst
       daarnaast naar drie zonder de klant iets voor te rekenen wat niet klopt. */
    var drieBlok = $("[data-eg-sprongdrie]");
    if (drieBlok) {
      if (n < 3 && doel === 2) {
        var drie = once(3);
        drieBlok.hidden = false;
        drieBlok.innerHTML = "Of meteen drie: <b>" + eur(meerkosten(basis, drie))
          + "</b> erbij, " + eur(Math.round(drie / 3 * 100) / 100) + " per potje. "
          + '<button type="button" data-eg-sprongknop data-eg-erbijaantal="' + (3 - n)
          + '" style="background:none;border:0;padding:0;font:inherit;color:inherit;'
          + 'text-decoration:underline;cursor:pointer">Maak er drie van</button>';
      } else {
        drieBlok.hidden = true;
        drieBlok.innerHTML = "";
      }
    }
  }


  /* ---------- quiz: drie vragen, dertig seconden ---------- */
  var QUIZ = [
    { v: "Waar ben je op dit moment het meest mee bezig?",
      hint: "Er is geen fout antwoord \u2014 we sturen je gewoon naar het potje dat het beste past.",
      opts: [
        { t: "Ik ben aan het eind van de dag helemaal leeg", s: { shilajit: 2, blackseed: 1 } },
        { t: "Mijn weerstand, huid of haar",                 s: { blackseed: 2, cranberry: 1 } },
        { t: "Ik wil rustiger door de dag komen",            s: { matcha: 2 } },
        { t: "Ik zoek iets voor mijn kind",                  s: { kids: 3 } }
      ] },
    { v: "Heb je eerder een supplement geprobeerd?",
      hint: "Dit bepaalt vooral of we je \u00e9\u00e9n potje of drie aanraden.",
      opts: [
        { t: "Ja, en ik hield het nooit vol",    s: {}, potjes: "drie" },
        { t: "Ja, en ik neem er nog steeds een", s: {}, potjes: "drie" },
        { t: "Nee, dit is mijn eerste keer",     s: {}, potjes: "een" }
      ] },
    { v: "Nog iets waar we rekening mee moeten houden?",
      hint: "Wij binden al onze gummies met pectine uit fruit, dus vegan en halal zijn nooit een probleem.",
      opts: [
        { t: "Ik eet halal of vegan",            s: {} },
        { t: "Ik hou niet van zure smaken",      s: { cranberry: -3 } },
        { t: "Ik hou juist van fris en fruitig", s: { cranberry: 1, matcha: 1 } },
        { t: "Nee, niets bijzonders",            s: {} }
      ] }
  ];
  var WAAROM = {
    shilajit:  "500 mg shilajit met co-enzym Q10, vitamine D en B12 \u2014 voor wie een dagelijkse routine wil die hij ook echt volhoudt.",
    blackseed: "De originele zwarte zaad gummy, en draagt het NZVT-keurmerk. 1000 mg per dag met biotine en vitamine C.",
    kids:      "Speciaal ontwikkeld voor groeiende kinderen van 4 t/m 13: eigen dosering, eigen samenstelling en blauwe bessensmaak. Twee per dag, een potje gaat een maand mee.",
    matcha:    "Matcha met magnesium en vitamines, en de enige met aardbeiensmaak. Fijn als je afwisseling wilt naast blauwe bes.",
    cranberry: "Cranberry met vitamine C, E, B6 en D3. Frisser en zuurder dan de rest."
  };
  var NAAM = { shilajit:"Shilajit Gummies", blackseed:"Zwarte Zaad Gummies", kids:"Zwarte Zaad Kids",
               matcha:"Matcha Gummies", cranberry:"Cranberry Gummies" };
  var qi = 0, qscore = null, qpotjes = "een";

  function qreset() {
    qi = 0; qpotjes = "een";
    qscore = { shilajit: 0, blackseed: 0, kids: 0, matcha: 0, cranberry: 0 };
  }

  function tekenQuiz() {
    var blok = $("[data-eg-quiz]");
    if (!blok) return;
    if (!qscore) qreset();
    var q = QUIZ[qi];
    $("[data-eg-qstap]").textContent = "Vraag " + (qi + 1) + " van " + QUIZ.length;
    $("[data-eg-qvraag]").textContent = q.v;
    $("[data-eg-qhint]").textContent = q.hint;
    $("[data-eg-qopts]").innerHTML = q.opts.map(function (o, i) {
      return '<button class="qopt" type="button" data-eg-qopt="' + i + '">' + o.t + "</button>";
    }).join("");
    $("[data-eg-qopts]").hidden = false;
    $("[data-eg-qres]").classList.remove("on");
  }

  function quizKlaar() {
    var best = "blackseed", bv = -99;
    Object.keys(qscore).forEach(function (k) { if (qscore[k] > bv) { bv = qscore[k]; best = k; } });
    var handle = null;
    SMAKEN.forEach(function (s) { if (s.k === best) handle = s.h; });
    $("[data-eg-qnaam]").textContent = NAAM[best];
    $("[data-eg-qwaarom]").textContent = WAAROM[best] + " " + (qpotjes === "drie"
      ? "Omdat je eerder bent afgehaakt, raden we drie potjes aan \u2014 of een abonnement, dan hoef je er nooit meer aan te denken."
      : "Begin met \u00e9\u00e9n potje. Bevalt het, dan is drie potjes voordeliger \u00e9n gratis verzonden.");
    if (handle) $("[data-eg-qga]").setAttribute("href", "/products/" + handle);
    state.tier = qpotjes === "drie" ? 2 : 0;
    tekenLadders();
    $("[data-eg-qstap]").textContent = "Klaar";
    $("[data-eg-qvraag]").textContent = "Dit past bij jou.";
    $("[data-eg-qhint]").textContent = "";
    $("[data-eg-qopts]").hidden = true;
    $("[data-eg-qres]").classList.add("on");
  }

  /* ---------- klantvideo's ----------
     Ze staan op preload="none" zodat ze de pagina niet vertragen. Alle vier
     starten zodra de strook in beeld komt - vier stilstaande posters naast
     elkaar overtuigen niemand. Geluid staat uit, dus er valt niets te storen. */
  function tekenVideos() {
    var rail = $(".vidrail");
    if (!rail) return;
    var kaarten = $$(".vidcard video", rail);
    if (!kaarten.length) return;

    kaarten.forEach(function (v) {
      var knop = v.parentNode.querySelector(".vid__b");
      function speel() {
        v.play().then(function () {
          if (knop) knop.style.display = "none";
        }).catch(function () {});
      }
      if (knop) knop.addEventListener("click", function (e) {
        e.preventDefault();
        if (v.paused) speel(); else { v.pause(); knop.style.display = ""; }
      });
      v.addEventListener("click", function () {
        if (v.paused) speel(); else { v.pause(); if (knop) knop.style.display = ""; }
      });
    });

    if (!("IntersectionObserver" in window)) return;
    var waarnemer = new IntersectionObserver(function (rijen) {
      rijen.forEach(function (r) {
        if (!r.isIntersecting) return;
        kaarten.forEach(function (v) {
          if (!v.paused) return;
          v.setAttribute("preload", "metadata");
          v.play().then(function () {
            var k = v.parentNode.querySelector(".vid__b");
            if (k) k.style.display = "none";
          }).catch(function () {});
        });
        waarnemer.disconnect();
      });
    }, { threshold: 0.25 });
    waarnemer.observe(rail);
  }

  function start() {
    veilig("staffelkiezer", tekenLadders);
    veilig("abonnement", tekenAbo);
    veilig("koopknop", tekenKoop);
    veilig("mix en match", tekenMix);
    veilig("bezorging", bezorging);
    veilig("winkelwagen", tekenWagen);
    veilig("quiz", tekenQuiz);
    veilig("bijkoopregel", tekenSprong);
    veilig("klantvideo's", tekenVideos);
    $$(".acc__b").forEach(function (b) {
      b.setAttribute("aria-expanded", !!b.closest(".acc__i").classList.contains("open"));
    });
    var st = $("[data-eg-sticky]");
    if (st) {
      var koop = $(".atc");
      /* Bewust met inline-stijlen in plaats van een klasse. De winkel-CSS wordt
         van een ander domein geserveerd en er staan meerdere .sticky-atc-regels
         door elkaar; met een klasse bleef de balk onzichtbaar. Zo staat het vast. */
      var chatEl = null, vorige = null;
      function zetBalk(aan) {
        if (aan === vorige) return;
        vorige = aan;
        st.classList.toggle("on", aan);
        st.style.transform = aan ? "translateY(0)" : "translateY(110%)";
        st.style.opacity = aan ? "1" : "0";
        st.style.pointerEvents = aan ? "auto" : "none";
        /* De chatknop van Shopify staat vast onderin met een z-index waar niets
           bovenuit komt, en dekte zo de bestelknop af. Hij schuift mee omhoog
           zolang de koopbalk in beeld is, en zakt daarna terug. */
        if (!chatEl) chatEl = document.querySelector(".egchat__knop");
        if (chatEl && window.innerWidth < 1024) {
          chatEl.style.transition = "transform .22s ease";
          chatEl.style.transform = aan ? "translateY(-" + (st.offsetHeight + 10) + "px)" : "";
        }
      }
      /* De controle zat alleen in de scroll-luisteraar. Op desktop staat de
         koopknop al bij het openen onder de vouw, en dan is er nog niet gescrold:
         de balk bleef dus uit op het moment dat hij juist nodig was. Daarom de
         controle in een eigen functie, die we ook één keer bij het laden draaien
         en opnieuw bij het kantelen of vergroten van het venster. */
      function kijk() {
        if (!koop) return;
        var vak = koop.getBoundingClientRect();
        if (window.innerWidth >= 1024) {
          var inBeeld = vak.bottom > 0 && vak.top < window.innerHeight;
          zetBalk(!inBeeld);
        } else {
          zetBalk(vak.bottom < 0);
        }
      }
      zetBalk(false);
      kijk();
      window.addEventListener("resize", kijk, { passive: true });
      window.addEventListener("scroll", function () {
        if (!koop) return;
        /* Mobiel: de balk komt pas als je de koopknop voorbij bent. Dat werkt daar
           goed en blijft zo -- mobiel is 92% van het verkeer en converteert het best.
           Desktop: daar toont hij zodra de knop niet in beeld is, dus ook als hij
           er nog ónder zit. Zie kijk() hierboven. */
        kijk();
      }, { passive: true });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();


  /* ---------- contactknop: WhatsApp, en het e-mailadres vastleggen ----------
     De chat van Shopify Inbox vroeg bezoekers eerst om in te loggen voordat ze
     iets konden vragen. Wie twijfelt over een aankoop maakt op dat moment geen
     account aan; die klikt weg. WhatsApp opent nu meteen. Daarnaast vangen we
     het e-mailadres op, zodat een vraag ook een contact oplevert als iemand het
     gesprek niet begint. */
  veilig("contactknop", function () {
    var paneel = document.getElementById("egchatPaneel");
    if (!paneel) return;
    var knop = document.querySelector("[data-egchat-open]");

    function zet(open) {
      paneel.hidden = !open;
      paneel.classList.toggle("on", open);
      knop.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) { var v = paneel.querySelector("input[type=email]"); if (v) setTimeout(function(){ v.focus(); }, 60); }
    }

    knop.addEventListener("click", function () { zet(paneel.hidden); });
    var sluit = paneel.querySelector("[data-egchat-close]");
    if (sluit) sluit.addEventListener("click", function () { zet(false); knop.focus(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !paneel.hidden) { zet(false); knop.focus(); } });
    document.addEventListener("click", function (e) {
      if (paneel.hidden) return;
      if (paneel.contains(e.target) || knop.contains(e.target)) return;
      zet(false);
    });

    var form = paneel.querySelector("[data-egchat-form]");
    if (!form) return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var mail = (form.mail.value || "").trim();
      var vraag = (form.vraag.value || "").trim();
      var fout = paneel.querySelector("[data-egchat-fout]");
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(mail)) { fout.hidden = false; form.mail.focus(); return; }
      fout.hidden = true;
      var verzend = form.querySelector("button[type=submit]");
      verzend.disabled = true; verzend.textContent = "Bezig\u2026";

      /* Via het contactformulier van Shopify: dat mailt de vraag door en legt
         het adres vast in de winkel. Bewust niet in de welkomstlijst, want dan
         zou iemand met een vraag een kortingsmail krijgen. */
      var d = new FormData();
      d.append("form_type", "contact");
      d.append("utf8", "\u2713");
      d.append("contact[email]", mail);
      d.append("contact[body]", (vraag || "Vraag via de contactknop op de site.") + "\n\nPagina: " + location.href);

      fetch("/contact", { method: "POST", body: d })
        .then(function () {
          form.hidden = true;
          paneel.querySelector("[data-egchat-ok]").hidden = false;
        })
        .catch(function () {
          verzend.disabled = false; verzend.textContent = "Versturen";
          fout.textContent = "Versturen lukte niet. Probeer WhatsApp hierboven.";
          fout.hidden = false;
        });
    });
  });

})();
